export const VIRTUAL_SPORTS_MENUS = [
  {
    _id: '63806ca440b4a5aea422f07c',
    component_content_id: '63806ca340b4a5aea422f07b',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link: null,
    link_type: 1,
    sequence: 1,
    image_desktop_path: {
      'en-US': 'demo/games/sportbooks/image-1-en.png',
      'th-TH': 'demo/games/sportbooks/image-1-th.png',
      'zh-CN': 'demo/games/sportbooks/image-1-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/sportbooks/image-1-en-mobile.png',
      'th-TH': 'demo/games/sportbooks/image-1-th-mobile.png',
      'zh-CN': 'demo/games/sportbooks/image-1-ch-mobile.png'
    },
    image_path: {},
    currency: 'thb'
  },
  {
    _id: '63806ca440b4a5aea422f07a',
    component_content_id: '63806ca340b4a5aea422f07b',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link: null,
    link_type: 1,
    sequence: 1,
    image_desktop_path: {
      'en-US': 'demo/games/sportbooks/image-2-en.png',
      'th-TH': 'demo/games/sportbooks/image-2-th.png',
      'zh-CN': 'demo/games/sportbooks/image-2-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/sportbooks/image-2-en-mobile.png',
      'th-TH': 'demo/games/sportbooks/image-2-th-mobile.png',
      'zh-CN': 'demo/games/sportbooks/image-2-ch-mobile.png'
    },
    image_path: {},
    currency: 'thb'
  },
  {
    _id: '63806ca440b4a5aea422f07q',
    component_content_id: '63806ca340b4a5aea422f07b',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link: null,
    link_type: 1,
    sequence: 1,
    image_desktop_path: {
      'en-US': 'demo/games/sportbooks/image-3-en.png',
      'th-TH': 'demo/games/sportbooks/image-3-th.png',
      'zh-CN': 'demo/games/sportbooks/image-3-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/sportbooks/image-3-en-mobile.png',
      'th-TH': 'demo/games/sportbooks/image-3-th-mobile.png',
      'zh-CN': 'demo/games/sportbooks/image-3-ch-mobile.png'
    },
    image_path: {},
    currency: 'thb'
  },
  {
    _id: '63806ca440b4a5aea422f032',
    component_content_id: '63806ca340b4a5aea422f07b',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link: null,
    link_type: 1,
    sequence: 1,
    image_desktop_path: {
      'en-US': 'demo/games/sportbooks/image-4-en.png',
      'th-TH': 'demo/games/sportbooks/image-4-th.png',
      'zh-CN': 'demo/games/sportbooks/image-4-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/sportbooks/image-4-en-mobile.png',
      'th-TH': 'demo/games/sportbooks/image-4-th-mobile.png',
      'zh-CN': 'demo/games/sportbooks/image-4-ch-mobile.png'
    },
    image_path: {},
    currency: 'thb'
  },
  {
    _id: '63806ca440b4a5aea422f0aa',
    component_content_id: '63806ca340b4a5aea422f07b',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link: null,
    link_type: 1,
    sequence: 1,
    image_desktop_path: {
      'en-US': 'demo/games/sportbooks/image-5-en.png',
      'th-TH': 'demo/games/sportbooks/image-5-th.png',
      'zh-CN': 'demo/games/sportbooks/image-5-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/sportbooks/image-5-en-mobile.png',
      'th-TH': 'demo/games/sportbooks/image-5-th-mobile.png',
      'zh-CN': 'demo/games/sportbooks/image-5-ch-mobile.png'
    },
    image_path: {},
    currency: 'thb'
  }
]
